export default __webpack_public_path__ + "static/media/game3.608ceb73.jpeg";